var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-action-dialog',{attrs:{"api-call":_vm.apiCall,"action":"Accept dispute","disable-devmode":true},on:{"close":_vm.close}},[_c('p',[_vm._v("Accepting the dispute means to consider it as `lost`. This action cannot be undone. Are you sure?.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }